// extracted by mini-css-extract-plugin
module.exports = {"content":"RoomInfoDrawer_content__3TPz4"};